<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="center"><em>The DMC Series</em></p>
<p class="center">OFFICER-CADET<br/>LIEUTENANT<br/>CAPTAIN<br/>MAJOR<br/>LIEUTENANT COLONEL<br/>COLONEL</p>
<p class="center"><em>Other Books by Rick Shelley</em></p>
<p class="center"><em>The Spec Ops Squad</em><br/>HOLDING THE LINE<br/>DEEP STRIKE<br/>SUCKER PUNCH</p>
<p class="center"><em>The Lucky 13th</em><br/>UNTIL RELIEVED<br/>SIDE SHOW<br/>JUMP PAY</p>
<p class="center"><em>The Federation War</em><br/>THE BUCHANAN CAMPAIGN<br/>THE FIRES OF COVENTRY<br/>RETURN TO CAMEREIN</p>
<p class="center"><em>The Varayan Memoir</em><br/>SON OF THE HERO<br/>THE HERO OF VARAY<br/>THE HERO KING</p>
<p class="center"><em>The Seven Towers</em><br/>THE WIZARD AT MECQ<br/>THE WIZARD AT HOME</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0441005683_epub_atb_r1.vue?f36f8f86